import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-system",
  "use": "icon-system-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-system\"><defs><style type=\"text/css\"></style></defs><path d=\"M385.060913 828.085982v126.768195h-97.357352c-16.236799 0-29.398564 13.440104-29.398564 28.721135v5.934153c0 15.862269 12.534478 28.721135 28.713972 28.721135h449.625394c15.858176 0 28.713972-13.440104 28.713972-28.721135v-5.934153c0-15.862269-13.56597-28.721135-29.40061-28.721135h-97.361445l0.001023-126.768195H385.060913z m507.059477-697.184653H131.542942v507.043105h760.577448V130.901329z m63.38154 570.422597H68.168566V67.51979h887.333364v633.804136z m0-697.191816H68.168566c-35.011398 0-63.387679 28.382421-63.387679 63.38768v633.804136c0 34.999119 28.375258 63.386656 63.387679 63.386656h887.333364c34.999119 0 63.375399-28.387537 63.375399-63.386656V67.51979c-0.001023-35.005258-28.376281-63.387679-63.375399-63.38768z\" p-id=\"17185\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/system.svg
// module id = Jax1
// module chunks = 45